import { Reveal } from "./Reveal";

const reasons = [
  { title: "Market observation", body: "We closely study property markets, locations and rental demand." },
  { title: "Strategic property selection", body: "We identify properties with strong potential — we don't simply sell what's available." },
  { title: "Ownership-focused models", body: "Our models are designed around property ownership, including land and building ownership where applicable." },
  { title: "Project experience", body: "Multiple projects completed, one under development, and more being onboarded." },
  { title: "Transparent process", body: "We explain the property, structure, costs and requirements before moving forward." },
];

export const WhyChoose = () => (
  <section id="why" className="bg-ink py-20 md:py-28" data-testid="why-section">
    <div className="mx-auto max-w-7xl px-6 md:px-10">
      <Reveal>
        <p className="font-spec text-[11px] uppercase tracking-[0.25em] text-amber">Why choose Urban Veera</p>
        <h2 className="mt-5 max-w-3xl font-display text-3xl font-extrabold uppercase leading-[1.08] tracking-tight text-white sm:text-4xl lg:text-5xl" data-testid="why-headline">
          Selected carefully. <span className="text-amber">Structured honestly.</span>
        </h2>
      </Reveal>

      <div className="mt-12" data-testid="why-list">
        {reasons.map((r, i) => (
          <Reveal key={r.title} delay={i * 0.06}>
            <div className="flex flex-col gap-2 border-b border-white/10 py-7 sm:flex-row sm:items-baseline sm:gap-10" data-testid={`why-item-${i}`}>
              <span className="w-16 shrink-0 font-spec text-[11px] uppercase tracking-[0.2em] text-amber">{String(i + 1).padStart(2, "0")}</span>
              <h3 className="w-72 shrink-0 font-display text-xl font-extrabold tracking-tight text-white">{r.title}</h3>
              <p className="max-w-xl text-sm leading-relaxed text-white/60">{r.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
